var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4273_10261",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4273_10261",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACtUlEQVR4nO2cMXITMRhGXxgomYE2qXMCLkGgpYAZLkFHw32gSM9laJIyk8Ju7RkoDIMRsndtaaVP0vdmVMS7sX7p7b+S1rLBGGOMycdPsbIBPizaYnFqC4iVLfBxyUYrU7vzLSWgdsdbSkDYCSpxDCtFXchwUlSFbPhfyvtq0RVEVcg74lK6zxRVITCoFGUhMKAUdSEwmJQWhMBAUloRAoNIaUkIDCClNSHQuZQWhUDHUlSFnFs2NLSiv4i8FkqInVOCnBfDFniW8f0WYxQhUK8dJ/GkdgDmX57WDuAIqVd0zfHvbJwhYliIGBYihoWIYSFipMyyptYruWY55862mlh3hDhDxLAQMSxEDOVnWYdQX4En9ZczRAwLEcNCxOhhHVJ7jMs6pjlDxLAQMSxEjJQxRP3e3iTOEDEsRAwLESNFyNQOx7k7C38An4BXwMuEeLpl7lbSVCFb4DOnXxQqW13/sHg8JYRsgbcLx1eKLoR8KRBfKWSE5OQauAXWkfp7K2vgG3A1t3NKC7kGHiP19l4emCmltJDbSJ2jlK9hZyh8hLsGni9chyor4MX+CylCps47lF1T5/X+DOxoe71SF8NCxLAQMVKEXARl6vih83rjDXD/u9zkeMPS097S9S3NPX/bchc5frS9vmU1gDMkjRt2mXEHvI4cP9pehYWh1yF7+JYlhoWIYSFiKP+SwyHUB35/P6Qn5mRI7iuy91lUEs4QMVocQ0JqZ1zWO4gzRIxYhtS+4obGGSKGhYhhIWJYiBgWIoaFiGEhYigIWQd/T+2HVeeU+FfhPysI+V47gIpItv2K3db8c3eQ1+bcuB+AywrxzuKS3db8Ff0LWbFra1RGi8+t1HapZI1HYQwxe1iIGBYihoWIYSFiWIgYFiJGD7tOFBaH2XCGiGEhYliIMcYY0wm/AJB7+ZH9xJ6xAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetup);
export default __webpack_public_path__ + "static/media/User_setup.e2cfa1f7b6177e2c38ed88c33dc0489c.svg";
export { ForwardRef as ReactComponent };